<template>
  <transition name="fade">
    <div v-if="show" :class="rootClass" class="concept-root">
      <div class="sp-section first">
        <div class="bgs">
          <div :style="bg3Style" class="bg bg3"></div>
          <div :style="bg4Style" class="bg bg4"></div>
        </div>
      </div>

      <div class="sp-section second">
        <ul class="texts">
          <li class="text text1">
            <dl>
              <dt :style="text1IndexStyle" class="index"></dt>
              <dd class="content">
                <span :style="text11ContentStyle" class="text1-1">企業の</span>
                <span :style="text12ContentStyle" class="text1-2"
                  >システム開発</span
                >
              </dd>
            </dl>
          </li>

          <li class="text text2">
            <dl>
              <dt :style="text2IndexStyle" class="index"></dt>
              <dd class="content">
                <span :style="text21ContentStyle">企業の</span>
                <span :style="text22ContentStyle">インフラ環境</span>
                <span :style="text23ContentStyle">の構築・コンサル</span>
              </dd>
            </dl>
          </li>

          <li class="text text3">
            <dl>
              <dt :style="text3IndexStyle" class="index"></dt>
              <dd :style="text3ContentStyle" class="content">
                DX(デジタルトランスフォーメーション)のコンサル
              </dd>
            </dl>
          </li>

          <li class="text text4">
            <dl>
              <dt :style="text4IndexStyle" class="index"></dt>
              <dd class="content">
                <span :style="text41ContentStyle">システム間の</span>
                <span :style="text42ContentStyle">API連携</span>
                <span :style="text43ContentStyle">の開発・コンサル</span>
              </dd>
            </dl>
          </li>

          <li class="text text5">
            <dl>
              <dt :style="text5IndexStyle" class="index"></dt>
              <dd class="content">
                <span :style="text51ContentStyle">地方の企業</span>
                <span :style="text52ContentStyle"
                  >と共同で行える案件の調達</span
                >
              </dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  spTransformStyle1,
  spFadeStyle2,
  spTransformStyle2
} from '../../lib/spStyleGenerator'

export default {
  name: 'pageSpConcept',

  computed: {
    rootClass() {
      return this.scrollRate <= 0.5 ? 'first' : 'second'
    },

    show() {
      const currentPage = this.$store.getters.currentPage

      return currentPage === 'business'
    },
    scrollRate() {
      return this.$store.getters.businessPageRate
    },
    text1IndexStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { scale: 3, x: -20 }),
        ...spFadeStyle2(this.scrollRate, 5, 0.4)
      }
    },
    text11ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: 20 })
      }
    },
    text12ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: 50, scale: 1.8 }),
        ...spFadeStyle2(this.scrollRate)
      }
    },
    text2IndexStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 50 })
      }
    },
    text21ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 80 })
      }
    },
    text22ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: 50, scale: 1.8 }),
        ...spFadeStyle2(this.scrollRate)
      }
    },
    text23ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 80 })
      }
    },
    text3IndexStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 50 })
      }
    },
    text3ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: -40, scale: 1.3 }),
        ...spFadeStyle2(this.scrollRate, 1)
      }
    },
    text4IndexStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: -150, scale: 1.5 }),
        ...spFadeStyle2(this.scrollRate, 3)
      }
    },
    text41ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: 20 })
      }
    },
    text42ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: 70, scale: 1.3 }),
        ...spFadeStyle2(this.scrollRate, 1)
      }
    },
    text43ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: 120 })
      }
    },
    text5IndexStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 50 })
      }
    },
    text51ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: -50, x: -50, scale: 2 }),
        ...spFadeStyle2(this.scrollRate, 1)
      }
    },
    text52ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { x: 50, y: -50 })
      }
    },
    bg3Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { x: 200 })
      }
    },
    bg4Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { y: -200 })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.bgs
  overflow-x: hidden
  height: 600px
  position: relative

.bg
  position: absolute
  background-size: cover
  width: 375px
  height: 250px
  &3
    left: 30px
    top: 230px
    background-image: url('/images/bg/bg3.jpg')
  &4
    left: -40px
    top: 80px
    background-image: url('/images/bg/bg4.jpg')

.texts
  position: absolute
  width: 458px
  margin: 0
  padding: 0
  height: 360px
  top: 110px
  left: 40px
  .text
    list-style: none
    margin-bottom: 15px

    @each $index in 1,2,3,4,5
      &.text#{$index}
        dt
          background-image: url('/images/business-index-#{$index}.svg')

    dl
      margin: 0
    dt, dd
      font-weight: bold
    dt
      font-size: 30px
      width: 60px
      height: 24px
      background-repeat: no-repeat
      background-size: contain
    dd
      margin-left: 0
      font-size: 11px
      line-height: 36px
      vertical-align: top
      span
        display: inline-block
</style>
